import WishlistContainer from "../../../../Components/Applications/ECommerce/Wishlist/WishListContainer";

const Wishlist = () => {
  return <WishlistContainer />;
};

export default Wishlist;
